import { useEffect, useState } from 'react';
import { setTileConfig } from '../data/commands/tiles';
import { useCommandEnv } from '../data/hooks';
import { Button } from '../ui/Button';
import { Sheet } from '../ui/Sheet';
import { tileConfig, type TileRow } from './layout';
import { getTileDef } from './registry';

export function TileSettingsSheet({
  tileId,
  rows,
  onClose,
}: {
  tileId: string | null;
  rows: TileRow[];
  onClose(): void;
}) {
  const env = useCommandEnv();
  const row = rows.find((r) => r.id === tileId) ?? null;
  const def = row ? getTileDef(row.type) : undefined;
  const Settings = def?.Settings;
  const [draft, setDraft] = useState<unknown>(null);

  useEffect(() => {
    setDraft(row ? tileConfig(row) : null);
    // reset the draft only when a different tile is opened
  }, [tileId]);

  return (
    <Sheet
      open={Boolean(row && Settings)}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={def ? `${def.title} settings` : 'Tile settings'}
    >
      {row && Settings ? (
        <div className="flex flex-col gap-4">
          <Settings config={draft ?? tileConfig(row)} onChange={setDraft} />
          <Button
            variant="primary"
            onClick={async () => {
              await setTileConfig(env, row.id, draft ?? tileConfig(row));
              onClose();
            }}
          >
            Save
          </Button>
        </div>
      ) : null}
    </Sheet>
  );
}
